module.exports = __webpack_public_path__ + "img/contact-info-row-black.a8fa5635.png";